import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, Paper, Typography } from '@mui/material';
import VerticalAZCatalog from './VerticalAZCatalog';
import { peopleService } from '../../services/api';
import PersonForm from './PersonForm';
import { useConfirm } from '../Common/ConfirmDialog';

export default function NewPersonForm(){
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);
  const confirm = useConfirm();

  useEffect(()=>{ window.scrollTo({ top: 0, left: 0, behavior: 'auto' }); }, []);

  const handleSelect = async (p) => {
    setError('');
    if (!p) { setSelected(null); window.scrollTo({ top: 0, behavior:'smooth' }); return; }
    const id = p.Id ?? p.id;
    if (!id) { setSelected(null); return; }
    setLoading(true);
    try {
      const full = await peopleService.getById(id);
      setSelected(full);
      window.scrollTo({ top: 0, behavior:'smooth' });
    } catch (e) {
      setError(e?.response?.data || e.message);
      setSelected(null);
    } finally { setLoading(false); }
  };

  const title = selected ? `Edit Person: ${(selected.FirstName||selected.firstName||'').trim()} ${(selected.LastName||selected.lastName||'').trim()}`.trim() : 'Create Person';
  const modeLabel = selected ? 'Edit mode' : 'Create mode';

  return (
    <Box sx={{ p: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '300px 1fr' }, gap: 1 }}>
      <Box>
        <Paper sx={{ p: 1.5, mb: 1.5, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <Typography variant="subtitle1">Manage Person Records</Typography>
          <Button size="small" variant="outlined" onClick={()=> { setSelected(null); setRefreshKey(x=>x+1); window.scrollTo({top:0,behavior:'smooth'}); }}>New Person</Button>
        </Paper>
        <VerticalAZCatalog key={refreshKey} letter={null} onLetterChange={()=>{}} selectedId={selected?.Id ?? selected?.id} onSelect={handleSelect} collapsed={false} />
      </Box>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
          <Typography variant="h6">{title}</Typography>
          <Box sx={{ display:'flex', gap:1, alignItems:'center' }}>
            <Chip size="small" label={modeLabel} color={selected ? 'primary' : 'success'} variant="outlined" />
            {selected && (
              <Button size="small" color="error" variant="outlined" onClick={async ()=>{
                if (!selected?.Id && !selected?.id) return;
                const name = `${selected?.FirstName||selected?.firstName||''} ${selected?.LastName||selected?.lastName||''}`.trim();
                const ok = await confirm({ message: `Да изтрия ли лицето "${name}"?`, danger: true, confirmLabel: 'Delete' });
                if (!ok) return;
                try {
                  setLoading(true); setError('');
                  await peopleService.remove(selected.Id ?? selected.id);
                  window.dispatchEvent(new CustomEvent('hrapp.toast', { detail: { sev: 'success', msg: 'Person deleted' } }));
                  setSelected(null);
                  setRefreshKey(x=>x+1);
                } catch (e) {
                  const msg = e?.response?.data || e.message;
                  if (e?.response?.status === 409) {
                    const force = await confirm({
                      message: `${msg}\n\nForce delete с каскада? Това ще изтрие свързани записи.`,
                      danger: true, confirmLabel: 'Force delete',
                    });
                    if (force) {
                      try {
                        await peopleService.forceRemove(selected.Id ?? selected.id);
                        window.dispatchEvent(new CustomEvent('hrapp.toast', { detail: { sev: 'success', msg: 'Person force-deleted' } }));
                        setSelected(null);
                        setRefreshKey(x=>x+1);
                      } catch (e2) {
                        setError(e2?.response?.data || e2.message);
                      } finally { setLoading(false); }
                      return;
                    }
                  }
                  setError(msg);
                } finally { setLoading(false); }
              }}>Delete</Button>
            )}
          </Box>
        </Box>
        {error && <Typography variant="body2" color="error" sx={{ mb:1 }}>{error}</Typography>}
        <PersonForm person={selected ?? null} onSaved={(p)=> setSelected(p)} />
      </Paper>
    </Box>
  );
}

